import { backendURL, postRestURL } from "../utils/constants/constants";

export async function getVerifyToken({ token, userType }) {

    try {
        const response = await fetch(`${backendURL}/admin/validateAdminToken/${userType}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        });

        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getStaticPages() {
    try {
        const response = await fetch(`${postRestURL}/staticpage`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}